export const BASE_URL = 'http://localhost:8080';

export const URLS = {
  AUTH: {
    REGISTER: `/users/register`,
    LOGIN: `/users/login`,
    PROFILE: `/users/profile`,
    GET_PROFILE: `/users/getProfile`,
    STATUS: `/users/updateStatus`,
    AUTHENTICATE: `/users/authenticate`,
    SEND_OTP: `/users/forgetPassword`,
    VERIFY_OTP: `/users/verifyOtp`,
    RESET_PASSWORD: `/users/resetPassword`,
    LOGOUT: `/users/logout`,
    DELETE_USER: `/users/delete`,
    CHANGE_PASSWORD: `/users/changePassword`,
    UPDATE_STATUS: `/users/updateStatus`,
    FORGOT_PASSWORD: `/users/forgetPassword`,
    SIGNUP_OTP: `/users/verify-signup-otp`,
    RESEND_OTP: `/users/resend-signup-otp`,
  },
  FAQS: {
    GET_FAQS: `/faqs/list`,
  },
  ARTICLES: {
    GET_ARTICLE: `/articles/list`,
    GET_SINGLE_ARTICLE: `/articles/get`,
  },
  FEEDBACK: {
    GET_FEEDBACK: '/feedbacks/list',
  },
 WEEKBYWEEK:{
GET_WEEK:"/articles/article-by-topic"
 },
  GROUP: {
    GET_GROUP: `/groups`,
    CREATE_GROUP: `/groups/create`,
    MODIFY_OWNER: `/groups/owner`,
    ADD_MEMBER: `/groups/addMember`,
    REMOVE_MEMBER: `/groups/removeMember`,
    GET_TAGS: `/tags/getAllGroupTAGs`,
    REPORT_GROUP: `/groups/report`,
    GET_GROUP_DATA: `/groups`,
    GET_MY_GROUPS: `groups/my`,
    GET_GROUP_POSTS: `/groups`,
    DELETE_GROUP: `/groups/`,
    EXIT_GROUP: `/groups`,
  },
  BOOKMARK: {
    GET_BOOKMARK: `/bookmarks/get-bookmarks`,
    TOGGLE_BOOKMARK: `/bookmarks/toggle-bookmark`,
  },
  POSTS: {
    GET_POSTS: `/posts/getGroupPosts`,
    CREATE_POST: `/posts/create`,
    EDIT_POST: `/posts/edit`,
    DELETE_POST: `/posts/delete`,
    GET_TAGS: `/tags/getAllTAGs`,
    LIKE_POSTS: `/likes/likeOrUnlike`,
    GET_ACTIVITY: `/likes/listLikes`,
    REPORT_POST: `/posts/report`,
    POST_DATA: `/posts/getPostDetail`,
    ADD_COMMENT: `/comments/create`,
    DELETE_COMMENT: `/comments/delete`,
    EDIT_COMMENT: `/comments/edit`,
    LIST_COMMENTS: `/comments/list`,
    GET_MY_POSTS: `/posts/my/created`,
    GET_MY_COMMENTS: `/posts/my/comments`,
    REPORT_COMMENT: `/comments/report`,
    GET_COMMENT_DETAIL: `/comments/details`,
  },
  TOPICS: {
    GET_TOPICS: `/articleTags`,
  },
  BABY_NAMES: {
    GET_BABY_NAMES: `/babyNames`,
    TOGGLE_NAME_SAVE: `/babyNames/save`,
    GET_MY_SAVED_NAMES: `/babyNames/save`,
  },
  BLOG: {
    GET_ALL_BLOG: '/blog/getAllBlogs',
    GET_SINGLE_BLOG: '/blog/getById',
  },
  SEARCH_ARTICLES: {
    GET_SEARCH_ARTICLES: '/articles/getArticles',
  },
  COURSES: {
    GET_COURSES: '/courses/fetch',
    GET_SINGLE_COURSES: '/courses/fetch',
    GET_ACCORDION_COURSES: '/courses/fetch',
  },

  EMAIL_SUBSCRIPTION: '/subscriptions/subscribe',
  POLICY:{
    GET_POLICY_CONTENT:"/privacyPolicy/fetch"
  },
   ABOUT_US:{
    GET_ABOUT_US_CONTENT:"/aboutUs/fetch"
  },
  CONTACT:{
    CREATE_CONTACT:"/contact/create-form",
    GET_CONTACT_INFO:"/contact/fetch-forms"
  },
  TERM_OF_USE:{
    GET_TERM_CONTENT:"/termsOfUse/fetch"
  }
};
